import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/windows': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 93.7L183.6 68.4V245.8H0V93.7zM0 418.3L183.6 443.6V268.4H0V418.3zM203.8 446.3L448 480V268.4H203.8V446.3zM203.8 65.7V245.8H448V32L203.8 65.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/windows.js
// module id = oImK
// module chunks = 144